import { useEffect } from 'react'

import { conversationStatusMap } from '@/components/Chat/helpers'

import { Chats } from '../../firebase/collections'

const useChatListenerClosedConv = ({
  userRole,
  selectedBuilding,
  dispatchAddClosedConversationIds,
  dispatchRemoveClosedConversationIds,
}) => {
  const buildingIdNumber =
    selectedBuilding && typeof selectedBuilding === 'object'
      ? selectedBuilding.id
      : selectedBuilding

  useEffect(() => {
    if (
      ['PropertyManager', 'ShiftManager', 'Staff', 'Manager', 'Administrator'].includes(userRole)
    ) {
      const unsubscribeClosedAtListener = Chats.doc(`${buildingIdNumber}`)
        .collection('channelsWithLastMessage')
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            const channelChanged = change.doc.data()
            if (channelChanged.status === conversationStatusMap.CLOSED) {
              dispatchAddClosedConversationIds(change.doc.id, channelChanged.closedAt)
            } else {
              dispatchRemoveClosedConversationIds(change.doc.id)
            }
          })
        })

      return () => {
        unsubscribeClosedAtListener()
      }
    }
  }, [buildingIdNumber])
}

export default useChatListenerClosedConv
